import { render, staticRenderFns } from "./Motions.vue?vue&type=template&id=2470f57a&scoped=true"
import script from "./Motions.vue?vue&type=script&lang=js"
export * from "./Motions.vue?vue&type=script&lang=js"
import style0 from "./Motions.vue?vue&type=style&index=0&id=2470f57a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2470f57a",
  null
  
)

export default component.exports